import React from "react";

/**
 * DeleteDistroPreset Component
 * Confirmation dialog for deleting a distro preset
 */
const DeleteDistroPreset = ({ formData, onDiscard, handleSubmit }) => {
  return (
    <div className="container form-group text-center text-secondary col-sm-8 pt-5">
      <h3 className="row justify-content-md-center">
        Are you sure you want to delete this record?{" "}
        <b>
          <u>{formData.preset_name}</u>
        </b>
      </h3>
      <div className="pt-4">
      <button
        type="button"
        className="btn bg-orange form-btn"
        onClick={handleSubmit}
        aria-label="Confirm delete"
      >
        Yes
      </button>
      &nbsp;
      <button
        type="button"
        className="btn btn-secondary form-btn mx-3"
        onClick={onDiscard}
        aria-label="Cancel delete"
      >
        No
      </button>
      </div>
    </div>
  );
};

export default DeleteDistroPreset;
